import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";

export default function Salary() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [labours,  setLabours]  = useState([]);
  const [fetching, setFetching] = useState(true);
  const [loading,  setLoading]  = useState(false);
  const [result,   setResult]   = useState(null);
  const [error,    setError]    = useState("");
  const [labourId, setLabourId] = useState("");
  const [month, setMonth] = useState(() => {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
  });

  const navItems = [
    { label:"Dashboard",  emoji:"🏠", path:"/carpenter/dashboard" },
    { label:"My Labours", emoji:"👷", path:"/carpenter/labours" },
    { label:"Add Labour", emoji:"➕", path:"/carpenter/add-labour" },
    { label:"Attendance", emoji:"📋", path:"/carpenter/attendance" },
    { label:"Payments",   emoji:"💰", path:"/carpenter/payments" },
    { label:"Salary",     emoji:"💵", path:"/carpenter/salary", active:true },
  ];

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get("/carpenter/labours");
        setLabours(res.data.data || []);
      } catch(e) { console.error(e); }
      finally { setFetching(false); }
    })();
  }, []);

  const generateSalary = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setResult(null);
    try {
      const res = await api.post("/salary/generate", { labourId, month });
      const s   = res.data.salary;
      setResult({
        name:            s.labour?.name ?? selectedLabour?.name,
        // days
        fullDays:        s.fullDays        ?? 0,
        halfDays:        s.halfDays        ?? 0,
        overtimeDays:    s.overtimeDays    ?? 0,
        totalOTHours:    s.totalOTHours    ?? 0,
        absentDays:      s.absentDays      ?? 0,
        // rates
        dailyRate:       s.dailyRate       ?? 0,
        overtimeRate:    s.overtimeRate    ?? 0,
        // amounts
        fullAmount:      s.fullAmount      ?? 0,
        halfAmount:      s.halfAmount      ?? 0,
        overtimeAmount:         s.overtimeAmount         ?? 0,
        totalOvertimePay:       s.totalOvertimePay       ?? 0,
        overtimeAttendAmount:   s.overtimeAttendAmount   ?? 0,
        grossSalary:            s.totalSalary            ?? 0,
        advanceDeducted: s.paidAmount      ?? 0,
        netSalary:       s.remainingAmount ?? s.totalSalary ?? 0,
      });
    } catch(err) {
      setError(err.response?.data?.message || "Failed to generate salary.");
    } finally { setLoading(false); }
  };

  const selectedLabour = labours.find(l => l._id === labourId);

  const monthDisplay = m => {
    const [y, mo] = m.split("-");
    return new Date(y, mo-1).toLocaleString("en-IN",{month:"long",year:"numeric"});
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes fadeUp { from{opacity:0;transform:translateY(14px)} to{opacity:1;transform:translateY(0)} }
        @keyframes popIn  { from{opacity:0;transform:scale(0.95)} to{opacity:1;transform:scale(1)} }
        @keyframes spin   { to{transform:rotate(360deg)} }
        *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; background:#FAF7F4; }
        .sidebar { width:220px; flex-shrink:0; background:#fff; border-right:1.5px solid #E7E5E4; padding:24px 14px; display:flex; flex-direction:column; gap:6px; position:sticky; top:0; height:100vh; overflow-y:auto; }
        .topbar { display:none; }
        .hamburger { display:none; align-items:center; justify-content:center; width:40px; height:40px; border-radius:10px; border:1.5px solid #E7E5E4; background:#fff; cursor:pointer; flex-shrink:0; }
        .sidebar-overlay { display:none; position:fixed; inset:0; background:rgba(0,0,0,0.4); z-index:40; }
        .nav-btn { display:flex; align-items:center; gap:9px; width:100%; padding:10px 12px; border-radius:10px; border:none; background:none; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; font-weight:600; color:#78716C; cursor:pointer; transition:background .15s,color .15s; text-align:left; }
        .nav-btn:hover,.nav-btn.active { background:#FEF3C7; color:#D97706; }
        .nav-btn.danger:hover { background:#FEF2F2; color:#DC2626; }
        .form-input { width:100%; padding:12px 14px; border:1.5px solid #E7E5E4; border-radius:12px; font-family:'Plus Jakarta Sans',sans-serif; font-size:14px; color:#1C1917; outline:none; background:#FFF7ED; transition:border-color .2s,box-shadow .2s; }
        .form-input:focus { border-color:#D97706; box-shadow:0 0 0 3px rgba(217,119,6,.1); }
        .form-input:disabled { opacity:.6; cursor:not-allowed; }
        .slip-row { display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid #F5F5F4; }
        .slip-row:last-child { border-bottom:none; }
        .section-label { font-size:10px; font-weight:700; color:#A8A29E; letter-spacing:.7px; text-transform:uppercase; margin-bottom:10px; margin-top:4px; }
        @media (max-width:768px) {
          .sidebar { position:fixed; left:0; top:0; z-index:50; transform:translateX(-100%); transition:transform .28s ease; height:100%; }
          .sidebar.open { transform:translateX(0); }
          .sidebar-overlay.open { display:block; }
          .topbar { display:flex; align-items:center; gap:12px; padding:14px 16px; background:#fff; border-bottom:1.5px solid #E7E5E4; position:sticky; top:0; z-index:30; }
          .hamburger { display:flex; }
          .main-wrap { flex-direction:column !important; }
          .main-content { padding:16px !important; }
        }
        @media (min-width:769px) and (max-width:1100px) { .sidebar { width:190px; } }
      `}</style>

      <div className="main-wrap" style={{ display:"flex", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif", backgroundColor:"#FAF7F4" }}>
        <div className={`sidebar-overlay ${sidebarOpen?"open":""}`} onClick={() => setSidebarOpen(false)} />

        {/* SIDEBAR */}
        <aside className={`sidebar ${sidebarOpen?"open":""}`}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"28px", padding:"0 4px" }}>
            <div style={{ width:"36px", height:"36px", background:"linear-gradient(135deg,#92400E,#D97706)", borderRadius:"10px", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
              <span style={{ fontSize:"18px" }}>🪚</span>
            </div>
            <div>
              <p style={{ fontWeight:"800", fontSize:"15px", color:"#1C1917" }}>Craftigo</p>
              <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"500" }}>Carpenter Panel</p>
            </div>
          </div>
          <p style={{ fontSize:"11px", fontWeight:"700", color:"#C4B5A4", letterSpacing:"0.7px", textTransform:"uppercase", padding:"0 6px", marginBottom:"6px" }}>Menu</p>
          {navItems.map(n => (
            <button key={n.label} className={`nav-btn ${n.active?"active":""}`}
              onClick={() => { navigate(n.path); setSidebarOpen(false); }}>
              {n.emoji} {n.label}
            </button>
          ))}
          <div style={{ flex:1 }} />
          <div style={{ padding:"12px", background:"linear-gradient(135deg,#FEF3C7,#FFF7ED)", borderRadius:"12px", border:"1px solid #FDE68A", marginBottom:"10px" }}>
            <p style={{ fontSize:"12px", fontWeight:"700", color:"#92400E" }}>🪚 Carpenter</p>
            <p style={{ fontSize:"11px", color:"#B45309", marginTop:"2px" }}>Manage your team</p>
          </div>
          <button className="nav-btn danger" onClick={() => { localStorage.clear(); navigate("/login"); }}>🚪 Logout</button>
        </aside>

        {/* RIGHT */}
        <div style={{ flex:1, display:"flex", flexDirection:"column", minWidth:0 }}>
          <div className="topbar">
            <button className="hamburger" onClick={() => setSidebarOpen(true)}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6"  x2="21" y2="6"  stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="#44403C" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
            <span style={{ fontWeight:"800", fontSize:"16px", color:"#1C1917" }}>💵 Salary</span>
          </div>

          <main className="main-content" style={{ padding:"32px", flex:1, overflowY:"auto" }}>
            <div style={{ maxWidth:"580px", margin:"0 auto" }}>

              {/* Header */}
              <div style={{ marginBottom:"24px", animation:"fadeUp .35s ease both" }}>
                <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                  <div style={{ width:"44px", height:"44px", borderRadius:"12px", background:"linear-gradient(135deg,#4C1D95,#7C3AED)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"22px" }}>💵</div>
                  <div>
                    <h1 style={{ fontSize:"22px", fontWeight:"800", color:"#1C1917", letterSpacing:"-0.4px" }}>Salary Generator</h1>
                    <p style={{ fontSize:"13px", color:"#A8A29E" }}>Full day · Half day · Overtime — all calculated</p>
                  </div>
                </div>
              </div>

              {/* Error */}
              {error && (
                <div style={{ background:"#FEF2F2", border:"1.5px solid #FECACA", borderRadius:"14px", padding:"14px 18px", display:"flex", gap:"10px", alignItems:"center", marginBottom:"20px", animation:"popIn .25s ease" }}>
                  <span style={{ fontSize:"18px" }}>⚠️</span>
                  <p style={{ fontSize:"13px", fontWeight:"600", color:"#DC2626" }}>{error}</p>
                </div>
              )}

              {/* Form */}
              <div style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"20px", padding:"28px", marginBottom:"20px", animation:"fadeUp .4s .05s ease both" }}>
                <form onSubmit={generateSalary}>
                  <div style={{ display:"flex", flexDirection:"column", gap:"18px" }}>

                    {/* Labour select */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                        Select Labour <span style={{ color:"#DC2626" }}>*</span>
                      </label>
                      {fetching ? (
                        <div style={{ padding:"12px 14px", background:"#FFF7ED", border:"1.5px solid #E7E5E4", borderRadius:"12px", color:"#A8A29E", fontSize:"14px" }}>Loading…</div>
                      ) : (
                        <select value={labourId}
                          onChange={e => { setLabourId(e.target.value); setResult(null); setError(""); }}
                          required disabled={loading} className="form-input" style={{ cursor:"pointer" }}>
                          <option value="">— Choose a labour —</option>
                          {labours.map(l => <option key={l._id} value={l._id}>{l.name}</option>)}
                        </select>
                      )}
                      {selectedLabour && (
                        <div style={{ marginTop:"10px", background:"#FEF3C7", border:"1px solid #FDE68A", borderRadius:"10px", padding:"10px 14px" }}>
                          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                            <p style={{ fontSize:"13px", fontWeight:"700", color:"#92400E" }}>👷 {selectedLabour.name}</p>
                            <div style={{ display:"flex", gap:"8px" }}>
                              <span style={{ fontSize:"12px", fontWeight:"700", background:"#fff", color:"#B45309", padding:"3px 10px", borderRadius:"20px", border:"1px solid #FDE68A" }}>
                                ₹{selectedLabour.dailyRate}/day
                              </span>
                              {selectedLabour.overtimeRate > 0 && (
                                <span style={{ fontSize:"12px", fontWeight:"700", background:"#DBEAFE", color:"#0369A1", padding:"3px 10px", borderRadius:"20px", border:"1px solid #93C5FD" }}>
                                  ₹{selectedLabour.overtimeRate}/hr OT
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Month */}
                    <div>
                      <label style={{ fontSize:"12px", fontWeight:"700", color:"#44403C", display:"block", marginBottom:"7px" }}>
                        Month <span style={{ color:"#DC2626" }}>*</span>
                      </label>
                      <input className="form-input" type="month" value={month}
                        onChange={e => { setMonth(e.target.value); setResult(null); }}
                        required disabled={loading} />
                    </div>

                    {/* Submit */}
                    <button type="submit" disabled={loading}
                      style={{ padding:"14px", background:loading?"#E7E5E4":"linear-gradient(135deg,#4C1D95,#7C3AED)", border:"none", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"15px", fontWeight:"800", color:loading?"#A8A29E":"#fff", cursor:loading?"not-allowed":"pointer", display:"flex", alignItems:"center", justifyContent:"center", gap:"8px" }}>
                      {loading ? (
                        <>
                          <span style={{ width:"18px", height:"18px", border:"2.5px solid #C4B5A4", borderTop:"2.5px solid #78716C", borderRadius:"50%", animation:"spin .7s linear infinite", display:"inline-block" }} />
                          Calculating…
                        </>
                      ) : "📊 Generate Salary Slip"}
                    </button>
                  </div>
                </form>
              </div>

              {/* SALARY SLIP */}
              {result && (
                <div style={{ background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"20px", overflow:"hidden", animation:"popIn .35s ease" }}>

                  {/* Slip header */}
                  <div style={{ background:"linear-gradient(135deg,#4C1D95,#7C3AED)", padding:"24px 28px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", flexWrap:"wrap", gap:"12px" }}>
                      <div>
                        <p style={{ fontSize:"11px", fontWeight:"700", color:"rgba(255,255,255,.65)", letterSpacing:".7px", textTransform:"uppercase", marginBottom:"4px" }}>Salary Slip</p>
                        <h2 style={{ fontSize:"20px", fontWeight:"800", color:"#fff" }}>{result.name}</h2>
                        <p style={{ fontSize:"13px", color:"rgba(255,255,255,.7)", marginTop:"3px" }}>{monthDisplay(month)}</p>
                      </div>
                      <div style={{ background:"rgba(255,255,255,.15)", borderRadius:"12px", padding:"10px 18px", textAlign:"right" }}>
                        <p style={{ fontSize:"11px", color:"rgba(255,255,255,.65)", fontWeight:"600" }}>Net Salary</p>
                        <p style={{ fontSize:"26px", fontWeight:"800", color:"#fff" }}>₹{result.netSalary}</p>
                      </div>
                    </div>

                    {/* Day chips in header */}
                    <div style={{ display:"flex", gap:"8px", marginTop:"14px", flexWrap:"wrap" }}>
                      {result.fullDays > 0 && (
                        <span style={{ fontSize:"11px", fontWeight:"700", background:"rgba(255,255,255,.2)", color:"#fff", padding:"3px 10px", borderRadius:"20px" }}>
                          ✓ {result.fullDays} Full
                        </span>
                      )}
                      {result.halfDays > 0 && (
                        <span style={{ fontSize:"11px", fontWeight:"700", background:"rgba(255,255,255,.2)", color:"#fff", padding:"3px 10px", borderRadius:"20px" }}>
                          ½ {result.halfDays} Half
                        </span>
                      )}
                      {result.overtimeDays > 0 && (
                        <span style={{ fontSize:"11px", fontWeight:"700", background:"rgba(255,255,255,.2)", color:"#fff", padding:"3px 10px", borderRadius:"20px" }}>
                          ⏱ {result.overtimeDays} OT ({result.totalOTHours}h)
                        </span>
                      )}
                      {result.absentDays > 0 && (
                        <span style={{ fontSize:"11px", fontWeight:"700", background:"rgba(255,255,255,.15)", color:"rgba(255,255,255,.75)", padding:"3px 10px", borderRadius:"20px" }}>
                          ✗ {result.absentDays} Absent
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Slip body */}
                  <div style={{ padding:"22px 28px" }}>

                    {/* RATES SECTION */}
                    <p className="section-label">Rates</p>
                    <div style={{ background:"#FAF7F4", borderRadius:"12px", padding:"12px 16px", marginBottom:"16px", display:"flex", gap:"16px", flexWrap:"wrap" }}>
                      <div>
                        <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"600" }}>Daily Rate</p>
                        <p style={{ fontSize:"16px", fontWeight:"800", color:"#1C1917" }}>₹{result.dailyRate}</p>
                      </div>
                      <div style={{ width:"1px", background:"#E7E5E4" }} />
                      <div>
                        <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"600" }}>Overtime Rate</p>
                        <p style={{ fontSize:"16px", fontWeight:"800", color:"#0369A1" }}>
                          {result.overtimeRate > 0 ? `₹${result.overtimeRate}/hr` : "—"}
                        </p>
                      </div>
                      {result.totalOTHours > 0 && (
                        <>
                          <div style={{ width:"1px", background:"#E7E5E4" }} />
                          <div>
                            <p style={{ fontSize:"11px", color:"#A8A29E", fontWeight:"600" }}>Total OT Hours</p>
                            <p style={{ fontSize:"16px", fontWeight:"800", color:"#0369A1" }}>{result.totalOTHours}h</p>
                          </div>
                        </>
                      )}
                    </div>

                    {/* BREAKDOWN SECTION */}
                    <p className="section-label">Earnings Breakdown</p>

                    {/* Full day row */}
                    {result.fullDays > 0 && (
                      <div className="slip-row">
                        <div>
                          <p style={{ fontSize:"14px", color:"#1C1917", fontWeight:"600" }}>Full Days</p>
                          <p style={{ fontSize:"11px", color:"#A8A29E" }}>{result.fullDays} days × ₹{result.dailyRate}</p>
                        </div>
                        <span style={{ fontSize:"14px", fontWeight:"700", color:"#059669" }}>+₹{result.fullAmount}</span>
                      </div>
                    )}

                    {/* Half day row */}
                    {result.halfDays > 0 && (
                      <div className="slip-row">
                        <div>
                          <p style={{ fontSize:"14px", color:"#1C1917", fontWeight:"600" }}>Half Days</p>
                          <p style={{ fontSize:"11px", color:"#A8A29E" }}>{result.halfDays} days × ₹{result.dailyRate/2}</p>
                        </div>
                        <span style={{ fontSize:"14px", fontWeight:"700", color:"#D97706" }}>+₹{result.halfAmount}</span>
                      </div>
                    )}

                    {/* Overtime row */}
                    {(result.overtimeDays > 0 || result.totalOvertimePay > 0) && (
                      <div className="slip-row">
                        <div>
                          <p style={{ fontSize:"14px", color:"#1C1917", fontWeight:"600" }}>Overtime</p>
                          <p style={{ fontSize:"11px", color:"#A8A29E" }}>
                            {result.overtimeDays > 0
                              ? `${result.overtimeDays} days × ₹${result.dailyRate}`
                              : ""}
                            {result.overtimeDays > 0 && result.totalOvertimePay > 0 ? "  +  " : ""}
                            {result.totalOvertimePay > 0
                              ? `₹${result.totalOvertimePay} (manual)`
                              : ""}
                          </p>
                        </div>
                        <span style={{ fontSize:"14px", fontWeight:"700", color:"#0369A1" }}>
                          +₹{result.overtimeAmount}
                        </span>
                      </div>
                    )}

                    {/* Gross */}
                    <div className="slip-row">
                      <span style={{ fontSize:"14px", color:"#78716C", fontWeight:"600" }}>Gross Salary</span>
                      <span style={{ fontSize:"15px", fontWeight:"800", color:"#059669" }}>₹{result.grossSalary}</span>
                    </div>

                    {/* Advance + Payment deduction */}
                    <div className="slip-row">
                      <div>
                        <span style={{ fontSize:"14px", color:"#78716C", fontWeight:"600" }}>Total Paid</span>
                        <p style={{ fontSize:"11px", color:"#A8A29E" }}>Advance + Payments recorded</p>
                      </div>
                      <span style={{ fontSize:"14px", fontWeight:"700", color:"#DC2626" }}>
                        {result.advanceDeducted > 0 ? `-₹${result.advanceDeducted}` : "₹0"}
                      </span>
                    </div>

                    {/* Net payable */}
                    <div style={{ marginTop:"16px", background:"#F5F3FF", border:"1.5px solid #DDD6FE", borderRadius:"14px", padding:"16px 20px", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
                      <span style={{ fontSize:"15px", fontWeight:"800", color:"#4C1D95" }}>💵 Net Payable</span>
                      <span style={{ fontSize:"24px", fontWeight:"800", color:"#7C3AED" }}>₹{result.netSalary}</span>
                    </div>

                    {/* Actions */}
                    <div style={{ display:"flex", gap:"10px", marginTop:"18px" }}>
                      <button onClick={() => navigate("/carpenter/payments")}
                        style={{ flex:1, padding:"12px", background:"linear-gradient(135deg,#065F46,#059669)", border:"none", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"700", color:"#fff", cursor:"pointer" }}>
                        💸 Record Payment
                      </button>
                      <button onClick={() => { setResult(null); setLabourId(""); }}
                        style={{ padding:"12px 16px", background:"#fff", border:"1.5px solid #E7E5E4", borderRadius:"12px", fontFamily:"'Plus Jakarta Sans',sans-serif", fontSize:"13px", fontWeight:"700", color:"#78716C", cursor:"pointer" }}>
                        🔄 New
                      </button>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </main>
        </div>
      </div>
    </>
  );
}